import { IUser } from "@/types/user"
import { odooInstance } from "@/lib/axios"

export const doLogin = (payload: { user: string; password: string }) =>
  odooInstance.post<{ user: IUser; token: string }>("crm/staffs/login", payload)

export const getClientInfo = () => odooInstance.get("crm/staffs/me")
